import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarCenter } from '@/common/styles/SearchBars';

const SHIPPING_PROVIDERS = [
	{
		label: 'Paxy',
		value: 'paxy',
	},
	{
		label: 'Speedy',
		value: 'speedy',
	},
	{
		label: 'Fan Courier',
		value: 'fan_curier',
	},
];

const SearchBox = ({ hook }) => {
	return (
		<SearchBarCenter>
			<div>
				<Input
					name='Sent date from'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
				<Input
					name='Sent date to'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
			</div>
			<div>
				<SelectInput
					showLabel={false}
					placeholder={'Select provider...'}
					selectWidth={400}
					options={SHIPPING_PROVIDERS}
					setSelected={hook.setSelectedShippingProvider}
					selected={hook.selectedShippingProvider}
					multiple={true}
				/>
				<SelectInput
					showLabel={false}
					placeholder={'Select market...'}
					selectWidth={400}
					options={hook.marketsOptions}
					setSelected={hook.setSelectedMarkets}
					selected={hook.selectedMarkets}
					multiple={true}
				/>
			</div>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarCenter>
	);
};

export default SearchBox;
